import type { NotificationDto } from '@brandschutz/shared';
import { api } from '@/lib/api';

export async function listNotifications(
  unreadOnly?: boolean,
): Promise<{ items: NotificationDto[] }> {
  const { data } = await api.get<{ items: NotificationDto[] }>('/notifications', {
    params: unreadOnly ? { unreadOnly: true } : undefined,
  });
  return data;
}

export async function unreadCount(): Promise<{ unread: number }> {
  const { data } = await api.get<{ unread: number }>('/notifications/count');
  return data;
}

export async function markRead(id: number): Promise<void> {
  await api.patch(`/notifications/${id}/read`);
}

export async function markAllRead(): Promise<void> {
  await api.post('/notifications/read-all');
}

export async function deleteNotification(id: number): Promise<void> {
  await api.delete(`/notifications/${id}`);
}
